export default "__VITE_ASSET__DVboBUGB__"